import * as authApi from "@/commons/axios/auth";
import { LoginUser } from "@/commons/types";

type LoginParameter = {
  emailAddress: string;
  password: string;
};

type State = {
  user: LoginUser | null;
};

const auth = {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    getLoginUser: (state: State): LoginUser | null => {
      return state.user;
    },
  },
  mutations: {
    setLoginUser(state: State, user: LoginUser): void {
      state.user = user;
    },
  },
  actions: {
    // TODO: vuexの型推論の保管
    // eslint-disable-next-line no-empty-pattern
    login({}, requestParameter: LoginParameter): Promise<any> {
      return authApi.login({
        email: requestParameter.emailAddress,
        password: requestParameter.password,
      });
    },
    logout(): Promise<any> {
      return authApi.logout();
    },
    checkAuth(): Promise<any> {
      return authApi.isLogin();
    },
  },
};

export default auth;
